module.exports = __webpack_public_path__ + "static/tovixjun-f60c4f746a4b16bb794c4b3b6bbb5b82.gif";